import { apiService } from './apiService';

const providesPermissionGroups = { providesTags: ['PermissionGroups' as const] };
const providesCompanyUsers = { providesTags: ['CompanyUsers' as const] };
// A group's privileges show up in user lists and in /me, and its name in SSO mappings, so a change
// to a group refreshes all three.
const invalidatesGroups = {
  invalidatesTags: [
    'PermissionGroups' as const,
    'CompanyUsers' as const,
    'UserMe' as const,
    'OidcGroupMappings' as const,
  ],
};
// Mappings show up on the groups they point to (`directoryGroups`), so a change refreshes those too.
const invalidatesOidcGroupMappings = {
  invalidatesTags: ['OidcGroupMappings' as const, 'PermissionGroups' as const],
};
const invalidatesMemberships = { invalidatesTags: ['CompanyUsers' as const, 'UserMe' as const] };
// A campaign that is created, removed, renamed, started or stopped changes the overview counters
// and the paginated campaign list
const invalidatesCampaignSummaries = {
  invalidatesTags: ['CompanyOverview' as const, 'CampaignList' as const],
};

apiService.enhanceEndpoints({
  endpoints: {
    campaignControllerCampaign: {
      providesTags: (_result, _error, arg) => [{ type: 'Campaign', id: arg.id }],
    },
    handoffRuleCreateControllerExecute: {
      invalidatesTags: [{ type: 'Campaign' }],
    },
    companyOverviewControllerGetCompanyOverview: {
      providesTags: ['CompanyOverview'],
    },
    toolListControllerAgentTollList: {
      providesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolCreateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolUpdateControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    toolDeleteControllerCreateAgentTool: {
      invalidatesTags: (_result, _error, arg) => [{ type: 'AgentTools', id: arg.id }],
    },
    campaignCreateControllerCampaignCreate: invalidatesCampaignSummaries,
    campaignDeleteControllerDeleteCampaign: invalidatesCampaignSummaries,
    campaignRunControllerCampaignRun: invalidatesCampaignSummaries,
    campaignStopControllerCampaignStop: invalidatesCampaignSummaries,
    campaignUpdateControllerCampaignUpdate: { invalidatesTags: ['CampaignList'] },
    userMeControllerUserMe: {
      providesTags: ['UserMe'],
    },
    userUpdateControllerUpdate: invalidatesMemberships,
    userCreateControllerCreateUser: invalidatesMemberships,
    permissionGroupListControllerList: providesPermissionGroups,
    permissionGroupListControllerListForManager: providesPermissionGroups,
    userListControllerList: providesCompanyUsers,
    userListControllerListForManager: providesCompanyUsers,
    permissionGroupCreateControllerCreate: invalidatesGroups,
    permissionGroupCreateControllerCreateForManager: invalidatesGroups,
    permissionGroupUpdateControllerUpdate: invalidatesGroups,
    permissionGroupUpdateControllerUpdateForManager: invalidatesGroups,
    permissionGroupDeleteControllerDelete: invalidatesGroups,
    permissionGroupDeleteControllerDeleteForManager: invalidatesGroups,
    userPermissionGroupAttachControllerAttach: invalidatesMemberships,
    userPermissionGroupAttachControllerAttachForManager: invalidatesMemberships,
    userPermissionGroupDetachControllerDetach: invalidatesMemberships,
    userPermissionGroupDetachControllerDetachForManager: invalidatesMemberships,
    oidcGroupMappingListControllerList: { providesTags: ['OidcGroupMappings'] },
    oidcGroupMappingsReplaceControllerReplace: invalidatesOidcGroupMappings,
  },
});

export { apiService };
